module.exports = __webpack_public_path__ + "img/DJ-Presenting.8b60cbfc.jpg";